import { Card, CardContent } from "@/components/ui/card";
import Footer from "@/components/Footer";
import "../styles/globle.css";

const EmailVerificationPage = () => {
  return (
    <div className="login-container">
      {/* MAIN SECTION – identical layout to Login / PaymentCanceled */}
      <div className="flex items-center justify-center w-full px-4 pt-12 pb-24 md:pt-16 md:pb-32">
        {/* CARD – EXACT SAME CLASSNAMES AS LOGIN & PAYMENTCANCELED */}
        <Card className="w-full max-w-md p-8 rounded-2xl shadow-sm">
          <CardContent>
            <div className="text-center space-y-6">
              {/* Icon */}
              <div className="flex justify-center">
                <svg
                  className="w-16 h-16 text-blue-500"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={1.5}
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m-9 12a9 9 0 110-18 9 9 0 010 18z"
                  />
                </svg>
              </div>

              {/* Heading + body copy */}
              <div className="space-y-2">
                <h1 className="text-2xl font-bold text-gray-900">
                  Check your email
                </h1>
                <p className="text-base text-gray-600">
                  We’ve sent you a link to set your password. <br />
                  Please check your inbox and follow the steps.
                </p>
              </div>

              {/* CTA – visually identical to Login button */}
              <a
                href="https://mail.google.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="
                  inline-flex items-center justify-center
                  w-full h-11
                  text-base font-medium rounded-lg
                  bg-[#005FCC] hover:bg-[#0049A8]
                  text-white transition-colors
                "
              >
                Go to Email
              </a>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* FOOTER – same wrapper as Login / PaymentCanceled */}
      <div className="footer-container-login">
        <Footer />
      </div>
    </div>
  );
};

export default EmailVerificationPage;
